<template>
  <div
    id="score-slider-component"
    class="score-slider i-p-8"
    :class="confidenceScoreBgColorClass(20)"
  >
    <h5
      class="i-text-subheading-3 d-flex align-items-center i-m-0"
      :class="confidenceScoreColorClass(110)"
    >
      <i-icon
        :symbol="
          hasHighConfidenceScore ? 'small-solid-check' : 'small-solid-minus'
        "
        class="i-mr-4"
        :class="confidenceScoreColorClass(100)"
        :size="16"
      />
      {{ confidenceScoreTitle }}
    </h5>

    <div class="score-slider__wrapper">
      <i-tooltip
        :target="`#thumb-tooltip`"
        title="Customer is here"
        :alignment="tooltipPosition"
      />

      <div
        id="thumb-tooltip"
        class="score-slider__thumb i-text-button-3 d-flex align-items-center justify-content-center"
        :class="confidenceScoreBgColorClass(90)"
        :style="`left: ${
          credit.summary.confidence_score * 100
        }%; margin-left: -16px`"
      >
        {{ credit.summary.confidence_score }}
      </div>
      <div class="score-slider__axis">
        <div class="score-slider__axis--low"></div>
        <div class="score-slider__axis--high"></div>
      </div>
      <div class="d-flex justify-content-between i-mt-2">
        <div
          v-for="(tick, index) in ticks"
          :key="tick + index"
          class="score-slider__tick"
          :class="`score-slider__tick--${tick}`"
        ></div>
      </div>
      <div
        class="d-flex justify-content-between i-text-body-3 i-mt-2 i-text-neutral-100"
      >
        <span>0</span>
        <span>0.5</span>
        <span>1</span>
      </div>
      <div
        class="d-flex justify-content-between i-text-subheading-3 i-mt-1 i-text-neutral-110"
      >
        <span>Low</span>
        <span>High</span>
      </div>
    </div>

    <credit-confidence-score-info
      :has-high-confidence-score="hasHighConfidenceScore"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { iIcon, iTooltip, iTooltipAlignmentMode } from '@inscribe/signal';
import CreditConfidenceScoreInfo from './CreditConfidenceScoreInfo';

const LOWER_THRESHOLD = 0.13;
const UPPER_THRESHOLD = 0.89;

export default {
  components: {
    iIcon,
    iTooltip,
    CreditConfidenceScoreInfo,
  },
  data() {
    return {
      iTooltipAlignmentMode,
      showTooltip: true,
      ticks: [
        'lg',
        'sm',
        'sm',
        'sm',
        'sm',
        'lg',
        'sm',
        'sm',
        'sm',
        'sm',
        'lg',
        'sm',
        'sm',
        'sm',
        'sm',
        'lg',
        'sm',
        'sm',
        'sm',
        'sm',
        'lg',
      ],
    };
  },
  computed: {
    ...mapState(['credit']),

    ...mapGetters({
      creditConfidenceScoreThreshold: 'creditConfidenceScoreThreshold',
    }),

    hasHighConfidenceScore() {
      return (
        this.credit.summary?.confidence_score >=
        this.creditConfidenceScoreThreshold
      );
    },

    confidenceScoreTitle() {
      return `Inscribe Confidence Score: ${
        this.hasHighConfidenceScore ? 'High' : 'Low'
      }`;
    },

    tooltipPosition() {
      if (this.credit.summary?.confidence_score < LOWER_THRESHOLD) {
        return iTooltipAlignmentMode.TOP_LEFT;
      } else if (this.credit.summary?.confidence_score > UPPER_THRESHOLD) {
        return iTooltipAlignmentMode.TOP_RIGHT;
      } else {
        return iTooltipAlignmentMode.TOP_MIDDLE;
      }
    },
  },
  mounted() {
    this.hideTooltipAfterX(5);
  },
  methods: {
    confidenceScoreBgColorClass(weight) {
      return this.hasHighConfidenceScore
        ? `i-bg-success-${weight}`
        : `i-bg-error-${weight}`;
    },
    confidenceScoreColorClass(weight) {
      return this.hasHighConfidenceScore
        ? `i-text-success-${weight}`
        : `i-text-error-${weight}`;
    },
    hideTooltipAfterX(seconds) {
      setTimeout(() => {
        this.showTooltip = false;
      }, seconds * 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
$thumbDimension: 32px;
.score-slider {
  border-radius: 8px;

  &__wrapper {
    position: relative;
    margin-top: 81px;
  }

  &__thumb {
    position: absolute;
    top: -16px;
    width: $thumbDimension;
    height: $thumbDimension;
    border-radius: 50%;
    color: $light-neutral-default;
  }

  &__axis {
    display: flex;
    gap: 4px;
    height: 4px;

    &--low {
      flex: 1;
      background-color: $light-error-60;
    }
    &--high {
      flex: 1;
      background-color: $light-success-60;
    }
    &--low,
    &--high {
      border-radius: 2px;
    }
  }

  &__tick {
    width: 1px;
    background-color: $light-neutral-70;
    &--sm {
      height: 5px;
    }
    &--lg {
      height: 10px;
    }
  }
}
</style>
